<template>
    <Form
        :id="id"
        @model-load="$emit('model-load', $event)"
        @save="$emit('save', $event)"
        funcionalidade="livro-talidomida"
        ref="Form"
    />
</template>

<script>
import Form from '@/components/farmacia/livro/Form'

export default {
    components: { Form },
    methods: {
        print() {

            this.$refs.Form.print()
        },
        printTermoFechamento() {

            this.$refs.Form.printTermoFechamento()
        },
        save() {

            this.$refs.Form.save()
        },
        fecharLivro() {

            this.$refs.Form.fecharLivro()
        }
    },
    props: {
        id: { type: Number }
    },
}
</script>